import { isTrackingDisabled } from ".";

export const isLogRocketEnabled = () => {
  return (
    import.meta.env.VITE_APP_LOGOROCKET_ID &&
    import.meta.env.MODE !== "development" &&
    (import.meta.env.MODE === "production" || !isTrackingDisabled())
  );
};
